import { Badge } from '@payaca/ambrosia';
import UntitledIcon from '@payaca/untitled-icons';
import { FC } from 'react';

type Props = {
  team: { name: string };
  className?: string;
};

/**
 * A Task's Team assignee. Distinct from the circular avatar a User assignee
 * gets, so the two read apart at a glance.
 */
const TeamAssigneeBadge: FC<Props> = (props) => {
  const { team, className = 'max-w-44' } = props;

  return (
    <Badge
      colour="gray"
      variant="soft"
      label="Assigned to team"
      className={className}
    >
      <UntitledIcon
        name="users-01.3"
        className="size-3.5 shrink-0"
        aria-hidden
      />
      <span className="min-w-0 truncate" title={team.name}>
        {team.name}
      </span>
    </Badge>
  );
};

export default TeamAssigneeBadge;
